import React from "react";
import Button from "@material-ui/core/Button";
import { _get } from "../Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { enGB } from "react-date-range/dist/locale";
import ViewArticles from "../components/ReportingViews/ViewArticles";
import ViewVats from "../components/ReportingViews/ViewVats";
import { Table as TablePDF } from "@david.kucsai/react-pdf-table/lib/Table";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { format } from "date-fns";
import PdfGenerator from "../components/TablePdf/PdfGenerator";
import TextField from "@material-ui/core/TextField";
import { toast, ToastContainer } from "react-toastify";
import DataProcessorFilter from "../components/TakeawayDeliveryReporting/DataProcessorFilter";
import { useParams } from "react-router-dom";
import AuthorizationWrapper from "../components/AuthorizationWrapper";

Date.formatted = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(), (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join("-");
};

Array.naturalSort = function (arr, property) {
  var a,
    b,
    a1,
    b1,
    rx = /(\d+)|(\D+)/g,
    rd = /\d+/;
  return arr.sort(function (as, bs) {
    as = as[property];
    bs = bs[property];
    a = String(as).toLowerCase().match(rx);
    b = String(bs).toLowerCase().match(rx);
    while (a.length && b.length) {
      a1 = a.shift();
      b1 = b.shift();
      if (rd.test(a1) || rd.test(b1)) {
        if (!rd.test(a1)) return 1;
        if (!rd.test(b1)) return -1;
        if (a1 != b1) return a1 - b1;
      } else if (a1 != b1) return a1 > b1 ? 1 : -1;
    }
    return a.length - b.length;
  });
};

Date.addDays = function (days) {
  let date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

const fetchData = (pillarMerchantId, start, end) => {
  let url = "/nova/pillar_merchant/" + pillarMerchantId + "/reporting/day";
  if (start && end) {
    url +=
      "?fromdate=" +
      start.getFullYear() +
      "-" +
      (start.getMonth() + 1) +
      "-" +
      start.getDate() +
      "&todate=" +
      end.getFullYear() +
      "-" +
      (end.getMonth() + 1) +
      "-" +
      end.getDate();
  } else if (start) {
    url += "?fromdate=" + start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate();
  } else if (end) {
    url += "?todate=" + end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate();
  }

  return _get(url)
    .then((res) => {
      if (!res.data) {
        return Promise.resolve(null);
      } else if (res.data.length === 0) {
        return Promise.resolve([]);
      } else {
        return Promise.resolve(res.data);
      }
    })
    .catch(() => {
      return Promise.reject(null);
    });
};

export default function PillarReporting() {
  const [range, setRange] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [rawData, setRawData] = React.useState(null);
  const [fetching, setFetching] = React.useState(false);
  const [email, setEmail] = React.useState(
    localStorage.getItem("defaultEmailReporting") ? localStorage.getItem("defaultEmailReporting") : ""
  );
  const [pillarMerchantId, setPillarMerchantId] = React.useState(Number.parseInt(useParams().pillarMerchantId));
  const paramPillarMerchantId = Number.parseInt(useParams().pillarMerchantId);

  const fetchWithDates = (start, end) => {
    fetchData(pillarMerchantId, start, end)
      .then((data) => {
        window.reportingData = data;
        setRawData(data);
        setPillarMerchantId(paramPillarMerchantId);
        setFetching(false);
      })
      .catch(() => {
        setRawData(null);
        setPillarMerchantId(paramPillarMerchantId);
        setFetching(false);
      });
  };

  if (!fetching && (rawData === null || paramPillarMerchantId !== pillarMerchantId)) {
    setFetching(true);
    fetchWithDates(range.startDate, range.endDate);

    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }
  if (rawData === null || paramPillarMerchantId !== pillarMerchantId) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  let viewRangeInput = (
    <TablePDF data={[0]}>
      <TableHeaderPDF>
        <TableCellPDF weighting={0.3}>Reporting Kiosk</TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          From
        </TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          Until
        </TableCellPDF>
      </TableHeaderPDF>
      <TableBodyPDF>
        <TableCellPDF weighting={0.3} />
        <TableCellPDF weighting={0.3}>{format(range.startDate, "MMM d, yyyy")}</TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          {format(range.endDate, "MMM d, yyyy")}
        </TableCellPDF>
      </TableBodyPDF>
    </TablePDF>
  );

  let viewVatsPdf = null;
  let viewArticlesPdf = null;

  let data = null;
  if (rawData != null) {
    data = DataProcessorFilter(rawData);
  }

  return (
    <div>
      <div style={{ display: "flex" }}>
        <DateRangePicker
          locale={enGB}
          weekStartsOn={1}
          maxDate={new Date()}
          ranges={[range]}
          onChange={(newRange) => {
            if (newRange.selection.startDate !== range.startDate || newRange.selection.endDate !== range.endDate) {
              setFetching(true);
              setRange({
                key: "selection",
                startDate: newRange.selection.startDate,
                endDate: newRange.selection.endDate,
              });

              fetchWithDates(newRange.selection.startDate, newRange.selection.endDate);
            }
          }}
        />
      </div>

      {data === null || fetching ? (
        <div align="center">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <div>
          <Button
            variant={"outlined"}
            onClick={() => {
              PdfGenerator([viewRangeInput, viewVatsPdf, viewArticlesPdf], "", true);
            }}
          >
            Download PDF
          </Button>
          <TextField
            style={{ margin: "0 20px" }}
            label={"E-mail address"}
            variant={"outlined"}
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          />
          <Button
            variant={"outlined"}
            onClick={() => {
              localStorage.setItem("defaultEmailReporting", email);
              PdfGenerator([viewRangeInput, viewVatsPdf, viewArticlesPdf], email, false);
              toast.success("Verzonden!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }}
          >
            Send PDF
          </Button>

          <AuthorizationWrapper
            permission={"vat"}
            child={
              <div style={{ padding: "10px" }}>
                <ViewVats
                  vats={data.totalVats}
                  createPdf={(view) => {
                    viewVatsPdf = view;
                  }}
                />
              </div>
            }
          />
          <div style={{ padding: "10px" }}>
            <ViewArticles
              articleLevel={data.articleLevel}
              createPdf={(view) => {
                viewArticlesPdf = view;
              }}
            />
          </div>
        </div>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
